export default __webpack_public_path__ + "static/media/sounds.06c62eeb.mp3";